module.exports = __webpack_public_path__ + "static/media/raw-materials.9b7b6489.svg";